import React, { useState } from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import FlexLogo from "../../images/Flex_Orange_Icon.svg"
import navLogo from "../../images/flex-logo-nav.svg"
import navLogoMobile from "../../images/flex-mobile-logo.svg"

import styles from "./hero.module.css"

const Hero = ({ className }) => {
  const [toggleMobile, setToggleMobile] = useState(false)
  const [active, setActive] = useState(false)

  const { mobileImage, desktopImage } = useStaticQuery(
    graphql`
      query {
        mobileImage: file(relativePath: { eq: "hero_image_mobile_v2.png" }) {
          childImageSharp {
            fluid(maxWidth: 490, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        desktopImage: file(relativePath: { eq: "hero_image_v2_resized.png" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 4160) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  )

  const toggleMobileHandler = () => {
    setToggleMobile(!toggleMobile)
    setActive(!active)
  }

  const sources = [
    mobileImage.childImageSharp.fluid,
    {
      ...desktopImage.childImageSharp.fluid,
      media: `(min-width: 491px)`,
    },
  ]
  return (
    // <BackgroundImage className={styles.Masthead} fluid={sources}>
    //   <div className={styles.Title}>
    //     <h2>Your Routine</h2>
    //   </div>
    // </BackgroundImage>
    <div className={styles.Masthead}>
      <nav>
        <div className={styles.Logo}>
          <img src={FlexLogo} />
        </div>
        <div>
          <Link to={"contactus"} className={styles.NavLink}>
            Contact Us
          </Link>
        </div>
      </nav>
      <div className={styles.Title}>{/* <h2>Your Routine</h2> */}</div>
    </div>
  )
}

export default Hero
